<template>
  <section class="reload">
    <div @click="submit">
      <img src="/static/v2/match/reload_icon.png" alt />
      <span>{{$t('global.重新加载')}}</span>
    </div>
    <p>{{$t('global.加载出错，请检查网络连接')}}</p>
  </section>
</template>

<script>
export default {
  props: ["callback"],
  methods: {
    submit() {
      this.$emit("callback");
    }
  }
};
</script>

<style lang="stylus" scoped>
.reload {
  display: flex;
  flex-direction: column;
  align-items: center;

  div {
    display: flex;
    flex-direction: row;
    border: 1px solid #333333;
    width: 170px;
    height: 40px;
    align-items: center;
    justify-content: center;
    border-radius: 4px;

    &:hover {
      background: #F5F5F5;
    }

    span {
      font-size: 16px;
      color: #0A0A0A;
      padding-left: 5px;
    }

    img {
      width: 20px;
      height: 20px;
    }
  }

  p {
    color: #B8B8B8;
    padding-top: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-size: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/v2/match/reload.vue